import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MessageSquare, Github } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';

export default function ContactUs() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen">
      <Header onSearch={() => {}} />
      
      <div className="flex-1 bg-[#1a1625] pt-16">
        <div className="sticky top-16 bg-[#13111d] border-b border-gray-800 z-40">
          <div className="container mx-auto px-4">
            <div className="flex items-center h-12">
              <Link to="/" className="flex items-center space-x-2 text-white hover:text-purple-400">
                <ArrowLeft className="w-5 h-5" />
                <span>{t('common.contact_us')}</span>
              </Link>
            </div>
          </div>
        </div>
        
        <main className="container mx-auto px-4 py-8">
          <div className="bg-[#13111d] rounded-lg p-8 text-white">
            <h1 className="text-3xl font-bold mb-6">{t('contact.title')}</h1>
            
            <div className="space-y-8">
              <section>
                <p className="text-gray-300 leading-relaxed mb-8">
                  {t('contact.intro')}
                </p>
              </section>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-[#1E1A2E] p-6 rounded-lg">
                  <div className="flex items-center space-x-4 mb-4">
                    <Mail className="w-6 h-6 text-purple-400" />
                    <h2 className="text-xl font-semibold">{t('contact.email_support_title')}</h2>
                  </div>
                  <p className="text-gray-300 mb-4">
                    {t('contact.email_support_desc')}
                  </p>
                  <a 
                    href="mailto:oxo@elkroom.com" 
                    className="text-purple-400 hover:text-purple-300 block"
                  >
                    oxo@elkroom.com
                  </a>
                </div>

                <div className="bg-[#1E1A2E] p-6 rounded-lg">
                  <div className="flex items-center space-x-4 mb-4">
                    <MessageSquare className="w-6 h-6 text-purple-400" />
                    <h2 className="text-xl font-semibold">{t('contact.business_title')}</h2>
                  </div>
                  <p className="text-gray-300 mb-4">
                    {t('contact.business_desc')}
                  </p>
                  <a 
                    href="mailto:oxo@elkroom.com" 
                    className="text-purple-400 hover:text-purple-300 block"
                  >
                    oxo@elkroom.com
                  </a>
                </div>

                <div className="bg-[#1E1A2E] p-6 rounded-lg">
                  <div className="flex items-center space-x-4 mb-4">
                    <Github className="w-6 h-6 text-purple-400" />
                    <h2 className="text-xl font-semibold">{t('contact.developers_title')}</h2>
                  </div>
                  <p className="text-gray-300 mb-4">
                    {t('contact.developers_desc')}
                  </p>
                  <a 
                    href="mailto:oxo@elkroom.com" 
                    className="text-purple-400 hover:text-purple-300 block"
                  >
                    oxo@elkroom.com
                  </a>
                </div>

                <div className="bg-[#1E1A2E] p-6 rounded-lg">
                  <div className="flex items-center space-x-4 mb-4">
                    <MessageSquare className="w-6 h-6 text-purple-400" />
                    <h2 className="text-xl font-semibold">{t('contact.response_time_title')}</h2>
                  </div>
                  <p className="text-gray-300">
                    {t('contact.response_time_desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
} 